import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/navigation';
import { companyInfo } from '@/mocks/navigation';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 text-foreground-950 no-underline">
            <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-edit-2-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold tracking-wide">{companyInfo.name}</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white hover:text-primary-200'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/#"
              className={`text-sm font-medium whitespace-nowrap px-4 py-2 rounded-md transition-colors duration-200 cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white hover:text-primary-200'
              }`}
            >
              登录
            </Link>
            <Link
              to="/#"
              className="text-sm font-medium whitespace-nowrap px-5 py-2 bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer no-underline"
            >
              免费试用
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 transition-colors duration-200 whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
            <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
              <Link
                to="/#"
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 px-4 py-2 whitespace-nowrap"
              >
                登录
              </Link>
              <Link
                to="/#"
                className="text-sm font-medium px-5 py-2 bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 whitespace-nowrap cursor-pointer no-underline"
              >
                免费试用
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}